









































import { Component, Vue } from 'vue-property-decorator';
import { AccountInvoiceDataEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stAccountApi } from '@/services/st-api';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';
import StTextarea from '@/components/basic/StTextarea.vue';
import { notifySuccess } from '@/utlitities/notifications';

@Component({
  components: {
    StTextarea,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
  },
})
export default class EditAccountInvoiceData extends Vue {
  private id: number = 0;
  private invoiceData: AccountInvoiceDataEditModel = AccountInvoiceDataEditModel.fromJS({ name: '' });
  private loading: boolean = true;
  private listPage: string = 'Payment';

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  created() {
    this.id = parseInt(this.$route.params.id);
  }

  get countries(): any[] {
    const countries = ['Deutschland', 'Österreich', 'Schweiz', 'Dänemark'];
    return countries.map((_) => {
      return { value: _, description: _ };
    });
  }

  async mounted() {
    this.openSlideIn();

    this.invoiceData = await stAccountApi.getAccountInvoiceDataEditModel();
    this.loading = false;
  }

  async submit() {
    await stAccountApi.saveAccountInvoiceDataEditModel(this.invoiceData);

    notifySuccess('Erfolgreich gespeichert');
    this.closeSlideIn();
  }
}
